/* global CONFIG */
const request = require('browser-request')

export default {
  getTimezone (VueApp, data, callback) {
    let url2 = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz'
    url2 = url2.replace('{AT}', encodeURIComponent(data.lat + ',' + data.lng))
      .replace('{API_KEY}', CONFIG.hereApi.key)
    request.get({
      url: url2,
      json: true
    }, function (err, res, body) {
      if (err) { console.log(err) }
      if (body.items.length) {
        callback(body.items[0].timeZone.name)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/location.js